<template>
  <div class="invoice-payments-list page page-with-table p-2">
    <page-header class="mb-2">
      <template v-slot:title>
        <div style="flex: 1">
          <h1 class="mb-0">{{ $t('Invoice Payments') }}</h1>
        </div>
      </template>
    </page-header>
    <div class="card content-wrapper">
      <div class="pl-2 pr-2 pt-2  pb-0">
        <div class="row">
          <div class="col-md-4">
            <amount-viewer :title="$t('Total Amount')" text-class="text-primary" key="items-general-info"
                           :amount="totalAmount" icon="money-bill"/>
          </div>
        </div>
      </div>
      <InvoicePaymentTable :hide-actions="hideInvoiceActions" :hide-action-buttons="hideActionButtons"
                     enable-frontend-export/>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import PageHeader from "@/core/components/page-header/PageHeader";
  import InvoicePaymentTable from "@/modules/invoice-payments/InvoicePaymentTable";
  import AmountViewer from "@/core/components/common/AmountViewer";
  import {ON_INVOICE_PAYMENT_TABLE_GET_TABLE_DATA} from "@/plugins/event-bus/event-bus-names";
  import InvoicesService from "@/modules/invoices/InvoicesService";

  const {mapActions: invoicesMapActions} = createNamespacedHelpers('invoicePayments');

  export default {
    name: "InvoicePayments",
    components: {AmountViewer, InvoicePaymentTable, PageHeader},
    data() {
      return {
        hideActions: [],
        hideActionButtons: [],
        totalAmount: {}
      }
    },
    computed: {
      hideInvoiceActions() {
        let actions = _.cloneDeep(this.hideActions)
        return this.enableContinuousAuction ? actions : [...actions];
      },
    },
    methods: {
      ...invoicesMapActions(['updateTableSource']),
      async getFilteredInvoicesTotalAmounts({params}) {
        let response = await InvoicesService.getInvoicePaymentsTotalAmounts(params);
        if (response.success) {
          this.$set(this, 'totalAmount', response.body.total_amount);
        }
      },
    },
    async beforeMount() {
      this.$evBus.$on(ON_INVOICE_PAYMENT_TABLE_GET_TABLE_DATA, this.getFilteredInvoicesTotalAmounts);
      await this.updateTableSource({
        source: 'finance',
      });
    },
    beforeDestroy() {
      this.$evBus.$off(ON_INVOICE_PAYMENT_TABLE_GET_TABLE_DATA);
    }
  }
</script>

<style scoped lang="scss">
  @import "./scss/variables.scss";

  .invoice-payments-list {
    @include list-view-wrapper;
  }
</style>
